import { render, staticRenderFns } from "./EnterPhoneNumber.vue?vue&type=template&id=475f6624&scoped=true&"
import script from "./EnterPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./EnterPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./EnterPhoneNumber.vue?vue&type=style&index=0&id=475f6624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475f6624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
